import { Button } from "antd";
import { Dispatch, SetStateAction, useState } from "react";
import Flex from "../../../components/Flex";
import { emptyCoverQuoteInitialValues } from "../OrderContextMenu/CoverWizardModal/CoverWizardModal";
import {
  CreateHardwareOrderForm,
  CreateHardwareOrderModal,
  emptyCreateHardwareOrderForm,
} from "../CreateHardwareOrderModal/CreateHardwareOrderModal";
import { SubmittedOrderModalPayload } from "../OrderContextMenu/CoverWizardModal/components/SubmittedOrderModal";

type OrderActionsBarProps = {
  newOrderButton: boolean;
  newRgaButton: boolean;
  cloneOrderButton: boolean;
  newHardwareOrderButton: boolean;
  replacementLookup: boolean;
  setPoolToolWizardPayload: (payload: any) => void;
  submittedModalPayloadState: [
    SubmittedOrderModalPayload | null,
    Dispatch<SetStateAction<SubmittedOrderModalPayload | null>>,
  ];
  onReplacementLookup: () => void;
  onRefresh: () => void;
};

export function OrderActionsBar({
  newOrderButton,
  newRgaButton,
  cloneOrderButton,
  newHardwareOrderButton,
  replacementLookup,
  setPoolToolWizardPayload,
  submittedModalPayloadState,
  onReplacementLookup,
  onRefresh,
}: OrderActionsBarProps) {
  return (
    <Flex wrap="wrap" gap={8} style={{ width: "100%" }}>
      {newOrderButton ? (
        <Button
          disabled={false}
          loading={false}
          style={{ height: "37px", borderRadius: "8px" }}
          type="primary"
          title="New Cover Order/Estimate"
          onClick={() =>
            setPoolToolWizardPayload({
              initialValues: emptyCoverQuoteInitialValues,
            })
          }
        >
          New Cover Order/Estimate
        </Button>
      ) : null}
      {newRgaButton && (
        <Button
          type="primary"
          style={{ height: "37px", borderRadius: "8px" }}
          onClick={() =>
            setPoolToolWizardPayload({
              initialValues: emptyCoverQuoteInitialValues,
              startWithOrderTypePage: false,
              quoteIsRGA: true,
            })
          }
        >
          Return Cover To Meyco
        </Button>
      )}
      {/* {cloneOrderButton && (
        <Button
          type="primary"
          style={{ height: "37px", borderRadius: "8px" }}
          onClick={() =>
            setPoolToolWizardPayload({
              initialValues: emptyCoverQuoteInitialValues,
              startWithOrderTypePage: true,
            })
          }
        >
          Look up a Meyco Replacement
        </Button>
      )} */}
      {newHardwareOrderButton && (
        <CreateHardwareOrderButton
          onRefresh={onRefresh}
          submittedModalPayloadState={submittedModalPayloadState}
        />
      )}
      {replacementLookup && (
        <Button
          type="primary"
          style={{ height: "37px", borderRadius: "8px" }}
          onClick={onReplacementLookup}
        >
          Replacement Lookup
        </Button>
      )}
    </Flex>
  );
}

function CreateHardwareOrderButton({
  onRefresh,
  submittedModalPayloadState,
}: {
  onRefresh: () => void;
  submittedModalPayloadState: [
    SubmittedOrderModalPayload | null,
    Dispatch<SetStateAction<SubmittedOrderModalPayload | null>>,
  ];
}) {
  const [createHardwareOrderPayload, setCreateHardwareOrderPayload] =
    useState<CreateHardwareOrderForm | null>(null);

  return (
    <div>
      <Button
        type="primary"
        style={{ height: "37px", borderRadius: "8px" }}
        onClick={() => setCreateHardwareOrderPayload(emptyCreateHardwareOrderForm)}
      >
        Order Hardware
      </Button>
      {!!createHardwareOrderPayload && (
        <CreateHardwareOrderModal
          modalPayloadState={[createHardwareOrderPayload, setCreateHardwareOrderPayload]}
          submittedModalPayloadState={submittedModalPayloadState}
          onSubmit={onRefresh}
        />
      )}
    </div>
  );
}
